import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/health_business/doc_icon.png'
import _imports_1 from '../assets/images/health_business/chance_icon.png'


const _withScopeId = n => (_pushScopeId("data-v-3a7bcf04"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top" }
const _hoisted_2 = { class: "top__wrap" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "비즈니스 히스토리", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createTextVNode(" 다양한 협력사와 함께한"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("더조인의 비즈니스 사례 ")
], -1))
const _hoisted_5 = { class: "top__wrap__nav" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-right" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-right" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "active" }, "비즈니스 히스토리", -1))
const _hoisted_9 = { class: "wrap" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "더조인은", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createTextVNode(" 지자체 대규모 중점 추진 사업을"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("지원하고 있습니다. ")
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "doc-title" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("b", null, "서울형 헬스케어 사업"),
    /*#__PURE__*/_createElementVNode("h3", null, "손목닥터9988"),
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createTextVNode(" 21년 서울시민 건강관리 사업 강화를 위해 서울형 헬스케어 사업이 추진되었으며,"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("21년부터 현재까지 당사가 제공하는 스마트 헬스케어 플랫폼으로 사업 운영 중 입니다. ")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "project-icon" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "9988icon"
    })
  ])
], -1))
const _hoisted_13 = { class: "doc" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "doc__img" }, null, -1))
const _hoisted_15 = {
  class: "doc__swipe",
  id: "card1"
}
const _hoisted_16 = { class: "pagenation" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "doc__cnt" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "doc__cnt__title" }, " 손목닥터 사업 운영현황 ", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "doc__cnt__sub" }, " 2차 사업은 1월에 오픈하여 현재 6개월동안 서비스를 제공하고 있으며, 23년 9월까지 연장하여 서비스 제공이 확정 ", -1))
const _hoisted_21 = { class: "cnt-box-wrap" }
const _hoisted_22 = ["innerHTML"]
const _hoisted_23 = { class: "cnt-box__unit" }
const _hoisted_24 = { class: "cnt-box__count" }
const _hoisted_25 = ["id"]
const _hoisted_26 = { class: "kk" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "kk__title" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("b", null, "경기도 기회소득 사업"),
    /*#__PURE__*/_createElementVNode("h3", null, "장애인 기회소득"),
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createTextVNode(" 23년 경기도에서 추진하는 기회소득 시범사업에 "),
      /*#__PURE__*/_createElementVNode("br", { class: "pbr" }),
      /*#__PURE__*/_createTextVNode("당사 스마트 헬스케어 플랫폼이 채택되었습니다. ")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "project-icon" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_1,
      alt: "경기도 기회소득 시범사업 icon"
    })
  ])
], -1))
const _hoisted_28 = { class: "kk__image" }
const _hoisted_29 = {
  class: "kk__image__swipe",
  id: "card2"
}
const _hoisted_30 = { class: "pagenation" }
const _hoisted_31 = ["src"]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "kk__image__intro" }, null, -1))
const _hoisted_33 = { class: "together" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "협력기관", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "together__sub" }, " 다양한 지자체와 연구기관, 업체들과 협력하였습니다. ", -1))
const _hoisted_36 = ["id"]
const _hoisted_37 = { class: "panel__title" }
const _hoisted_38 = ["src"]
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_40 = { class: "pbr" }
const _hoisted_41 = { class: "tbr" }
const _hoisted_42 = ["onClick"]
const _hoisted_43 = ["onClick"]
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-arrow_down" }, null, -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "연구과제", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "together__sub" }, " 다양한 연구개발기관과 함께 헬스케어 관련 연구를 진행하고 있습니다. ", -1))
const _hoisted_47 = { class: "research-wrap" }
const _hoisted_48 = { class: "research-wrap__box__title" }
const _hoisted_49 = { class: "research-wrap__box__title__img" }
const _hoisted_50 = ["src"]
const _hoisted_51 = { class: "research-wrap__box__title__text" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_53 = { class: "research-wrap__box__body" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "gray" }, "활용도구", -1))
const _hoisted_55 = { class: "point" }
const _hoisted_56 = { class: "research-wrap__box__body" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "gray" }, "과제명", -1))
const _hoisted_58 = { class: "bold" }
const _hoisted_59 = { class: "research-wrap__box__body" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "gray" }, "관리 기관", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Layout = _resolveComponent("Layout")!

  return (_openBlock(), _createBlock(_component_Layout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _createElementVNode("p", _hoisted_5, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/')))
            }, " 홈 "),
            _hoisted_6,
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/health')))
            }, " 헬스케어 플랫폼 "),
            _hoisted_7,
            _hoisted_8
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _hoisted_11,
        _hoisted_12,
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.docImg, (item, index) => {
                return (_openBlock(), _createElementBlock("span", {
                  class: _normalizeClass(["dot", 
								$setup.docActiveIndex == index
									? 'active'
									: null
							]),
                  key: item.i
                }, null, 2))
              }), 128))
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.docImg, (img, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: img.i,
                class: _normalizeClass(["swipe-img", 
							index == $setup.docActiveIndex
								? 'active'
								: null
						])
              }, [
                _createElementVNode("img", {
                  src: img,
                  alt: "image"
                }, null, 8, _hoisted_17)
              ], 2))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _hoisted_20,
            _createElementVNode("div", _hoisted_21, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.docCntVal, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "cnt-box",
                  key: item.i
                }, [
                  _createElementVNode("p", {
                    innerHTML: item.title,
                    class: "cnt-box__title"
                  }, null, 8, _hoisted_22),
                  _createElementVNode("span", _hoisted_23, _toDisplayString(item.unit[0]), 1),
                  _createElementVNode("p", _hoisted_24, [
                    _createElementVNode("span", {
                      class: "count",
                      id: 'count' + (index + 1)
                    }, null, 8, _hoisted_25),
                    _createElementVNode("span", {
                      class: _normalizeClass(
										index == 2
											? 'count not'
											: 'small'
									)
                    }, _toDisplayString(item.unit[1]), 3)
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _hoisted_27,
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.chanceImg, (item, index) => {
                  return (_openBlock(), _createElementBlock("span", {
                    class: _normalizeClass(["dot chance", 
									$setup.chanceActiveIndex == index
										? 'active'
										: null
								]),
                    key: item.i
                  }, null, 2))
                }), 128))
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.chanceImg, (img, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: img.i,
                  class: _normalizeClass(["swipe-img chance", 
								index == $setup.chanceActiveIndex
									? 'active'
									: null
							])
                }, [
                  _createElementVNode("img", {
                    src: img,
                    alt: "image"
                  }, null, 8, _hoisted_31)
                ], 2))
              }), 128))
            ]),
            _hoisted_32
          ])
        ]),
        _createElementVNode("div", _hoisted_33, [
          _hoisted_34,
          _hoisted_35,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.together, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "panel",
              key: item.i,
              id: 'tags' + index
            }, [
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("img", {
                  src: item.icon,
                  alt: "icon"
                }, null, 8, _hoisted_38),
                _createElementVNode("p", null, [
                  _createElementVNode("b", null, _toDisplayString(item.title), 1),
                  _hoisted_39,
                  _createElementVNode("span", _hoisted_40, _toDisplayString(item.arr.length) + "개소", 1),
                  _createElementVNode("span", _hoisted_41, _toDisplayString(item.arr.length) + "개소", 1)
                ])
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["tags", 
							$setup.checkOverflow('tags' + index)
								? 'overflow'
								: null
						])
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.arr, (tag) => {
                  return (_openBlock(), _createElementBlock("span", {
                    class: "tag",
                    key: tag.i
                  }, _toDisplayString(tag), 1))
                }), 128))
              ], 2),
              (
							$setup.checkOverflow('tags' + index) ||
							item.show
						)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "icon-arrow_down arrow",
                    onClick: ($event: any) => (
							[
								$setup.toggleClass('tags' + index),
								(item.show = true),
							]
						)
                  }, null, 8, _hoisted_42))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                class: "mbr",
                onClick: ($event: any) => (
							[
								$setup.toggleClass('tags' + index),
								(item.show = true),
							]
						)
              }, [
                _createTextVNode(_toDisplayString(item.arr.length) + "개소 ", 1),
                _hoisted_44
              ], 8, _hoisted_43)
            ], 8, _hoisted_36))
          }), 128))
        ]),
        _hoisted_45,
        _hoisted_46,
        _createElementVNode("div", _hoisted_47, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.research, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "research-wrap__box",
              key: item.i
            }, [
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("div", _hoisted_49, [
                  _createElementVNode("img", {
                    src: item.icon,
                    alt: "icon"
                  }, null, 8, _hoisted_50)
                ]),
                _createElementVNode("p", _hoisted_51, [
                  _createElementVNode("b", null, _toDisplayString(item.name), 1),
                  _hoisted_52,
                  _createTextVNode(" " + _toDisplayString(item.period), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_53, [
                _hoisted_54,
                _createElementVNode("p", _hoisted_55, _toDisplayString(item.tool), 1)
              ]),
              _createElementVNode("div", _hoisted_56, [
                _hoisted_57,
                _createElementVNode("p", _hoisted_58, _toDisplayString(item.title), 1)
              ]),
              _createElementVNode("div", _hoisted_59, [
                _hoisted_60,
                _createElementVNode("p", null, _toDisplayString(item.center), 1)
              ])
            ]))
          }), 128))
        ])
      ])
    ]),
    _: 1
  }))
}